/* jshint multistr: true */

'use strict';

var StoreActions = require('js/shared/actions/store-actions.js'),
    _            = require('underscore');

/**
 *
 * This mixin is made to help the creation of new pages. It implements
 * `getInitialState` and `_updateState` to be extensions of the stores
 * that they are dedicated to following.
 *
 * `getInitialState` implements a call to an action's `loadPage` method
 * which manages the `dataIsLoaded` attribute of the store.
 *
 */

var _ = require('underscore');

var storeIsLoaded = function (store) {
    return store.getState().dataIsLoaded;
};

var getStoreState = function (store) {
    return store.getState();
};

var PiinPointPageMixin = function(stores) {

    var is_array = (Object.prototype.toString.call( stores ) === '[object Array]');
    if (!is_array)
        throw Error('You passed in an invalid `stores` attribute \
                     to the PageMixin -- must be Array.');

    return {

        getInitialState: function () {

            // merge all stores' states into one object, override dataIsLoaded
            // with the intersect of them all
            var state = _.extend(_.extend.apply(this, _.map(stores, getStoreState)), {
                dataIsLoaded: _.all(stores, storeIsLoaded)
            });

            _.each(stores, function (store) {
                if (!(storeIsLoaded(store)))
                    StoreActions.loadStore(store);
            });

            return state;
        },

        _updateState: function () {
            this.setState(_.extend(_.extend.apply(this, _.map(stores, getStoreState)), {
                dataIsLoaded: _.all(stores, storeIsLoaded)
            }));
        },

    };
};

module.exports = PiinPointPageMixin;



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/utils/page-mixin.js
 ** module id = 255
 ** module chunks = 0 1 6 7 8 9
 **/